import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'truncateString' })
export class TruncateStringPipe implements PipeTransform {
  transform(value: string, maxLengthAllowed: number) {
    if (value.length > maxLengthAllowed) {
      return value.slice(0, maxLengthAllowed) + '...';
    }
    return value;
  }
}
